import axios from 'axios'
import {ID} from '../../../../_metronic/helpers'
import {AuthModel, UserModel} from './_models'
import {SchoolModel} from '../../apps/school/schools-list/core/_models'
import {IUpdatePassword} from '../../apps/profile/components/settings/SettingsModel'

const API_URL = process.env.REACT_APP_API_URL
const API_V2_URL = process.env.REACT_APP_API_V2_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_V2_URL}/profile`
export const LOGIN_URL = `${API_V2_URL}/auth/login`
export const SWITCH_ACCOUNT_URL = `${API_V2_URL}/auth/switch_account`
export const REQUEST_PASSWORD_URL = `${API_URL}/auth/forgot_password`

export type LoginParams = {
  email: string
  password: string
  school_id?: ID
  token?: string
}
// Server should return AuthModel
export async function login(data: LoginParams) {
  const res = (await axios.post(LOGIN_URL, data)) as AuthModel & {
    schools: SchoolModel[]
  }
  return res
}

export type ApplicantLoginParams = {
  registration_no: string
  password: string
  school_id?: ID
}
// Server should return AuthModel
export async function applicantLogin(data: ApplicantLoginParams) {
  const res = (await axios.post(LOGIN_URL + '/applicant', data)) as AuthModel
  return res
}

// Server should return AuthModel
export async function switchAccount(account_id: ID) {
  const res = (await axios.post(SWITCH_ACCOUNT_URL, {
    account_id,
  })) as AuthModel
  return res
}

export const refreshToken = async (refresh_token: string) =>
  (await axios.post(API_V2_URL + '/auth/refresh_token', {refresh_token})) as AuthModel

export const forgetPassword = (values: any): Promise<IUpdatePassword> =>
  axios.post(`${API_V2_URL}/auth/forget_password`, values)

export const getUserByToken = async () => {
  return (await axios.get(GET_USER_BY_ACCESSTOKEN_URL)) as UserModel
}

export const GET_SCHOOL = `${API_V2_URL}/school/by_url`

export async function getSchool() {
  const res = (await axios.get(GET_SCHOOL)) as SchoolModel
  return res
}
export const verify_token = async (data: any): Promise<any> => {
  return await axios.post(`${API_V2_URL}/auth/verify_reset_token`, data?.queryKey[1])
}

export const changePassword = async (data: any) => {
  return await axios.post(`${API_V2_URL}/auth/change_password`, data)
}
